/**
 * The sums behind the sidebar timer. The clock is kept as the moment it runs out rather
 * than a count of ticks, so a tab the browser pauses comes back with the right time left
 * instead of however many ticks it was allowed.
 */
export const TIMER_PRESETS = [5, 15, 25] as const;
export const DEFAULT_TIMER_MINUTES = 25;
export const TIMER_BAR_CELLS = 18;

const pad = (value: number): string => String(Math.floor(value)).padStart(2, "0");

/** mm:ss, counting minutes past an hour rather than growing an hours column. */
export const formatRemaining = (seconds: number): string =>
  `${pad(Math.max(0, seconds) / 60)}:${pad(Math.max(0, seconds) % 60)}`;

/** Seconds left at `now`, rounded up so a timer reads its full length the moment it starts. */
export const remainingAt = (endsAt: number, now: number): number =>
  Math.max(0, Math.ceil((endsAt - now) / 1000));

/**
 * The bar as block characters, which is the one progress meter that follows the theme's
 * font and colours for free.
 */
export function timerBar(
  remaining: number,
  total: number,
  cells = TIMER_BAR_CELLS,
): string {
  const left = total > 0 ? Math.min(1, Math.max(0, remaining / total)) : 0;
  const full = Math.round(left * cells);
  return "█".repeat(full) + "░".repeat(cells - full);
}
